import { useGetMembersPlaces } from "@birdwatch/client";

import type { MyPlaceListItem } from "@/features/my/_types";

/** `-1` fetches every place in one request (`/members/places` caps it at 100,000); members rarely have more than a few. */
const MY_PLACES_LIST_TAKE = -1;

/**
 * Hook to fetch the member's places list.
 * Wraps useGetMembersPlaces from @birdwatch/client with consistent return type.
 * BLOCKER: the member places list should allow include HomePlan data (see _docs/BLOCKER.md).
 */
export function useMyPlaces({
  refetchOnWindowFocus = true,
}: {
  refetchOnWindowFocus: boolean;
}) {
  const { data, isLoading } = useGetMembersPlaces()
    .query({ take: MY_PLACES_LIST_TAKE })
    .get({ refetchOnWindowFocus });

  const places = (data || []) as MyPlaceListItem[];

  return {
    places,
    isLoading,
  };
}
